import { useTranslation } from 'react-i18next';

export type Locale = 'ru' | 'en' | 'uz';

export const LOCALES: Locale[] = ['ru', 'en', 'uz'];

export function useCurrentLocale(): Locale {
  const { i18n } = useTranslation();
  const lang = i18n.language ?? 'en';
  if (lang.startsWith('ru')) return 'ru';
  if (lang.startsWith('uz')) return 'uz';
  return 'en';
}
